module.exports = __webpack_public_path__ + "media/images/plans/photo_chapel/hall-list/plan-photowedding-lineup-kanto-2-2e0f2908a6796be626aa58e53d6885ae.png";